export enum ErpCustomerOrderState {
	Gueltig = 20,
	Freigegeben = 30,
	Fertig = 40,
	Geliefert = 50,
	Fakturiert = 60,
	Abgeschlossen = 70,
	Storniert = 80,
	CreditOverdrawn = 100,
	InStornierung = 900,
}
